import * as React from 'react';
import * as styles from './styles.css';

import { Outside, Header4 } from '@cian/ui-kit';

export interface IDesktopViewProps extends React.PropsWithChildren {
  isOpen: boolean;
  onClose(): void;
}

export const DesktopView: React.FC<IDesktopViewProps> = ({ children, onClose, isOpen }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Outside onOutside={onClose}>
      <div className={styles['container']}>
        <div className={styles['title']}>
          <Header4>Расскажите подробнее</Header4>
        </div>
        {children}
      </div>
    </Outside>
  );
};

DesktopView.displayName = 'DesktopView';
